export default __webpack_public_path__ + "static/media/circle-o-tick-azure.3c911669.svg";